<template>
  <v-app>
    <AppBar />
    <Drawer />

    <v-main>
      <router-view />
      <v-alert :value="alert.show" dense :type="alert.type" class="custom-alert">
        <div class="d-flex justify-sm-space-between align-center">
          {{ alert.text }}
          <v-btn icon color="white" @click="closeAlert">
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>
      </v-alert>

      <!-- Diálogo Universal -->
      <v-dialog v-model="dialog.visible" :max-width="dialog.maxWidth" :persistent="dialog.persistent"
        :scrollable="dialog.scrollable">
        <v-card :color="$vuetify.theme.dark ? 'grey darken-3' : 'white'">
          <v-card-title class="primary white--text d-flex justify-space-between align-center">
            <span>{{ dialog.title }}</span>
            <v-btn v-if="dialog.showClose" icon @click="closeDialog">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text :class="{ 'pt-4': true, 'dialog-scrollable': dialog.scrollable }">
            <component v-if="dialog.component" :is="dialog.component" v-bind="dialog.props" @close="closeDialog"
              @confirm="handleConfirm"></component>
            <div v-else>
              <p v-html="dialog.message"></p>
              <v-form v-if="dialog.fields && dialog.fields.length" ref="dialogForm" v-model="dialogFormValid">
                <v-container fluid>
                  <v-row>
                    <v-col v-for="(field, index) in dialog.fields" :key="index" cols="12">
                      <v-text-field v-if="field.type === 'text' || field.type === 'email' || field.type === 'number'"
                        v-model="fieldValues[field.model]" :label="field.label" :type="field.type" :rules="field.rules"
                        :required="field.required" outlined dense></v-text-field>
                      <v-textarea v-else-if="field.type === 'textarea'" v-model="fieldValues[field.model]"
                        :label="field.label" :rules="field.rules" :required="field.required" outlined dense
                        rows="3"></v-textarea>
                      <v-select v-else-if="field.type === 'select'" v-model="fieldValues[field.model]"
                        :items="field.items" :label="field.label" :rules="field.rules" :required="field.required"
                        outlined dense></v-select>
                      <v-checkbox v-else-if="field.type === 'checkbox'" v-model="fieldValues[field.model]"
                        :label="field.label" :rules="field.rules" :required="field.required"></v-checkbox>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </div>
          </v-card-text>

          <v-divider v-if="dialog.actions && dialog.actions.length"></v-divider>

          <v-card-actions v-if="dialog.actions && dialog.actions.length">
            <v-spacer></v-spacer>
            <v-btn v-for="(action, index) in dialog.actions" :key="index" :color="action.color" :text="!action.filled"
              :depressed="action.filled" @click="handleAction(action)">
              {{ action.text }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-main>
    <v-btn v-show="showScroll" color="primary" @click="scrollToTop" fab dark small fixed bottom right>
      <v-icon>expand_less</v-icon>
    </v-btn>
  </v-app>
</template>

<script>
import AppBar from "./components/AppBar.vue";
import Drawer from "./components/Drawer";
import { mapMutations, mapState } from "vuex";

export default {
  name: "App",
  components: { AppBar, Drawer },
  data: () => ({
    showScroll: false,
    dialogFormValid: false,
    fieldValues: {},
  }),
  mounted() {
    window.addEventListener("scroll", this.onScroll)
    let oldLink = document.querySelector("link[rel*='icon']");
    oldLink.href = this.company.image;
    if (this.theme.dark !== null) {
      this.$vuetify.theme.dark = this.theme.dark
    } else {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      if (mediaQuery.matches) this.$vuetify.theme.dark = true;
      else this.$vuetify.theme.dark = false;
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.userModule,
      company: (state) => state.companyModule,
      alert: (state) => state.alertModule,
      theme: (state) => state.themeModule,
      dialog: (state) => state.dialogModule // Asegúrate de tener este módulo en Vuex
    }),
  },
  watch: {
    'dialog.visible': function (newVal) {
      if (newVal) {
        // Inicializar valores de campos cuando el diálogo se abre
        this.initializeFieldValues();
      }
    }
  },
  methods: {
    ...mapMutations('alertModule', ['closeAlert']),
    ...mapMutations('dialogModule', ['closeDialog', 'setDialogData']),

    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    onScroll(e) {
      this.showScroll = e.target.documentElement.scrollTop > 0
    },

    initializeFieldValues() {
      if (this.dialog.fields && this.dialog.fields.length) {
        this.fieldValues = {};
        this.dialog.fields.forEach(field => {
          this.$set(this.fieldValues, field.model, field.default || '');
        });
      }
    },

    handleAction(action) {
      if (action.handler) {
        // Si hay un manejador específico, ejecutarlo
        action.handler({
          values: this.fieldValues,
          close: this.closeDialog
        });
      } else if (action.type === 'confirm' || action.type === 'submit') {
        // Para acciones de confirmación/enviar
        if (this.dialog.fields && this.dialog.fields.length) {
          if (this.$refs.dialogForm.validate()) {
            this.handleConfirm(this.fieldValues);
          }
        } else {
          this.handleConfirm();
        }
      } else if (action.type === 'cancel') {
        // Para acciones de cancelar
        this.closeDialog();
      }
    },

    handleConfirm(data = null) {
      if (this.dialog.onConfirm) {
        this.dialog.onConfirm(data || this.fieldValues);
      }
      this.closeDialog();
    }
  },
};
</script>

<style lang="scss">
@import "src/scss/index.scss";

.dialog-scrollable {
  max-height: 60vh;
  overflow-y: auto;
}
</style>